// extracted by mini-css-extract-plugin
module.exports = {"glossaryListItem":"TheoryGlossary_glossaryListItem__3rfbP","glossaryLink":"TheoryGlossary_glossaryLink__ICziV"};